import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import type {PageResponse} from "~/services/ApiTypes";
import {supplierExtLinkUrl} from "~/pages/supplier-360/services/supplier360PdlUrls";
import type {SupplierExtLink} from "~/pages/supplier-360/types/Supplier360PdlTypes";

/** The entity's company-data match status, or `undefined` when it has never been looked up at all. */
export function useSupplierExtLinkQuery(entityId: number | undefined) {
    const url = supplierExtLinkUrl(entityId ?? 0);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<PageResponse<SupplierExtLink>>(url)).data.results[0],
        enabled: Boolean(entityId),
    });
}
